import stockMessage from "../../helpers/stockMessage/stockMessage";
import stockMessageInputs from "../stock-status/stockMessageInputs";

export default function setItemStockStatus({ variant, quantity }) {
  const allocatedComponents = window.cartData?.allocatedComponents || {};
  const inputs = stockMessageInputs({
    variant,
    quantityRequested: quantity,
    allocatedComponents,
  });

  const messages = {
    inStock: {
      inStock: true,
      orderable: true,
      waitlist: false,
    },
    lowStock: {
      inStock: true,
      orderable: true,
      waitlist: false,
    },
    outOfStock: {
      inStock: false,
      orderable: false,
      waitlist: false,
    },
    reserveNow: {
      inStock: false,
      orderable: true,
      waitlist: false,
    },
    reserveNowDate: {
      inStock: false,
      orderable: true,
      waitlist: false,
    },
    notifyMe: {
      inStock: false,
      orderable: false,
      waitlist: true,
    },
    notifyMeDate: {
      inStock: false,
      orderable: false,
      waitlist: true,
    },
    madeToOrder: {
      inStock: false,
      orderable: true,
      waitlist: false,
    },
  };

  const message = stockMessage({ ...inputs, messages });

  return {
    ...message,
    backorderDate: inputs.backorderDate,
  };
}
